import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY


import * as React from 'react';
export default function FlagGQ(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtCAMAAAAun0N9AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABUUExURes1NP7+/kuqHvb29uUqKRuB2USdGk+wIOcvL0ejHOImJfr6+iCH4Bd70vLy8u/w7xWZQLTbwTJ+sS+P1qLK7Mvg8jmlWK0/VWxekUSjODaYgH3ElJ1mdxUAAAHbSURBVEjHpY6NuoMgCIZZP5uZWaettrPd/30eAUWtzp6tPgkReCF4Xg4JzPMgb+aD/JsBBdk6znkzF5/psk4Rf/0t9or4AwOYdwMaVtEUzhpR8i42co3ncUDKFf6k70WWw8Cbsdkl4fMBZ//F91kKWT7yZjxHNewI9KEUmqQv5c0zrWVdWxmelPI44Ftl/I4BUJv03E5fChIY3bcDFvsN/kF7aslObYgpXMX4gtphNcEUGTNxgdW/eonTPM6hB5gIo3f3JJ1lPw9zL9gpm8CCmmWi9wOQn4dhmMv2jYB+Os7A13Uqy9ZRzv0MPxLLTREf2Z/pyl1OyId4eZO2eNzPbS3tT5E2d1u8meJ4z/+vDX4qbenMOkPekjhHSRvqKKi7mo1PXd+sDYi1r+FlpTckZSLyAQ/fLe/KuxdzSt6fHt7er/h1hpPQdQne3XovrDmXaSsHSDnraM4Dvhat9et34MCLSXtw6EQjHOJHpQCNDhr4WyxeCiB0Rjyk0OhTyR1iSCO0uP1fQe7ymufVTjE/3jGu+KDz8q9KaiGrQo75e4VSVRV6vVRIRpNO9hDxj6WSGCKuq3DrBaC56K+s7Pi71g6hj4wmaO+05pDHSoOUAXFu21b1tqrhoQ/pD1dxTqHYoUniAAAAAElFTkSuQmCC",
    alt: "GQ"
  }, props));
}